module.exports = __webpack_public_path__ + "static/media/fourthareaproduct2.da0011f5.jpg";